<template>
    <v-tab-item :value="$route.path">
        <v-toolbar flat height="90">
            <v-spacer></v-spacer>
            <v-col cols="12" sm="4" class="pa-0">
                <b-search-field v-model="search"></b-search-field>
            </v-col>
        </v-toolbar>
        <v-data-table
            :headers="headers"
            :items="supplierGifts"
            :footer-props="{
                itemsPerPageOptions: [12],
                showCurrentPage: true,
                pageText: `${page * 12 - 11}-${
                    page * 12 <= serverItemsLength
                        ? page * 12
                        : serverItemsLength
                } ${translations.paginationText[lang]} ${serverItemsLength}`,
            }"
            :page.sync="page"
            :server-items-length="serverItemsLength"
            :loading="loading"
            disable-sort
            class="b-outlined"
        >
            <template v-slot:item.nameSurname="{ item }">
                {{
                    item.supplier_data &&
                    item.supplier_data.recipient_information
                        ? item.supplier_data.recipient_information.first_name +
                          " " +
                          item.supplier_data.recipient_information.last_name
                        : "-"
                }}
            </template>

            <template v-slot:item.address="{ item }">
                {{
                    item.supplier_data && item.supplier_data.recipient_address
                        ? checkAddress(
                              item.supplier_data.recipient_address.address
                          ) +
                          " " +
                          checkAddress(
                              item.supplier_data.recipient_address.city
                          ) +
                          " " +
                          checkAddress(
                              item.supplier_data.recipient_address.postal_code
                          ) +
                          " " +
                          checkAddress(
                              item.supplier_data.recipient_address.bell_name
                          ) +
                          checkAddress(
                              item.supplier_data.recipient_address.floor
                          ) +
                          " " +
                          checkAddress(
                              item.supplier_data.recipient_address.notes
                          )
                        : "-"
                }}
            </template>

            <template v-slot:item.deliver="{ item }">
                <v-btn
                    color="secondary"
                    class="text-capitalize px-5"
                    depressed
                    v-text="'Upload'"
                    @click="
                        () => {
                            dialog = true;
                            uploadingTransactionId = item.transaction_id;
                        }
                    "
                ></v-btn>
            </template>
        </v-data-table>

        <v-dialog v-model="dialog" max-width="500">
            <b-card
                title="Upload File"
                :submit-text="{ el: '', en: 'Save', it: '' }"
                @cancel="dialog = false"
                @submit="uploadFile(uploadingTransactionId)"
            >
                <v-file-input
                    class="mt-4"
                    label="Upload file"
                    color="secondary"
                    outlined
                    dense
                    hide-details
                    v-model="uploadingFile"
                ></v-file-input>
            </b-card>
        </v-dialog>
    </v-tab-item>
</template>

<script>
import { mdiMagnify, mdiChevronDown } from "@mdi/js";
import { mapMutations, mapState, mapActions } from "vuex";
import translations from "@/utils/translations/supplierPanel/sendReports";
import debounce from "lodash/debounce";

export default {
    name: "Pending",

    mixins: [translations],

    data() {
        return {
            icons: {
                mdiMagnify,
                mdiChevronDown,
            },
            uploadingTransactionId: null,
            search: "",
            page: +this.$route.query.page,
        };
    },
    computed: {
        ...mapState("supplierPanel/sendReports", ["supplierGifts"]),
        ...mapState(["loading", "serverItemsLength"]),

        lang() {
            return this.$route.params.lang;
        },

        uploadingFile: {
            get() {
                return this.$store.state.supplierPanel.sendReports
                    .uploadingFile;
            },
            set(val) {
                this.setUploadingFile(val);
            },
        },

        dialog: {
            get() {
                return this.$store.state.dialog;
            },

            set(val) {
                this.setDialog(val);
            },
        },

        headers() {
            return [
                {
                    text: this.translations.pon[this.lang],
                    value: "pon",
                },
                {
                    text: this.translations.dateTime[this.lang],
                    value: "created_at",
                },
                {
                    text: this.translations.giftName[this.lang],
                    value: "supplier_data.gift_details.title",
                },
                {
                    text: this.translations.nameSurname[this.lang],
                    value: "nameSurname",
                },
                {
                    text: this.translations.mobilePhone[this.lang],
                    value: "supplier_data.recipient_information.mobile",
                },
                {
                    text: this.translations.email[this.lang],
                    value: "supplier_data.recipient_information.email",
                },
                {
                    text: this.translations.address[this.lang],
                    value: "address",
                },
                {
                    text: this.translations.deliver[this.lang],
                    value: "deliver",
                },
            ];
        },

        query() {
            let query = "?";

            for (let key in this.$route.query) {
                query += `${key}=${this.$route.query[key]}&`;
            }

            return query.slice(0, query.length - 1);
        },
    },
    methods: {
        ...mapActions("supplierPanel/sendReports", [
            "getSupplierGifts",
            "uploadFile",
        ]),
        ...mapMutations("supplierPanel/sendReports", ["setUploadingFile"]),
        ...mapMutations(["setDialog"]),

        handleSearch() {
            if (this.search) {
                const body = {
                    query: `?q=${this.search}`,
                    status: 6,
                };
                this.getSupplierGifts(body);
            } else {
                const body = {
                    query: this.query,
                    status: 6,
                };
                this.getSupplierGifts(body);
            }
        },

        checkAddress(val) {
            if (val) {
                return val;
            } else {
                return "";
            }
        },
    },
    watch: {
        $route(val) {
            if (!val.query.page) {
                this.$router.push({
                    query: {
                        page: 1,
                        ...this.$route.query,
                    },
                });
            }
            const body = {
                query: this.query,
                status: 6,
            };
            this.getSupplierGifts(body);
        },

        page(page) {
            this.$router.push({ query: { ...this.$route.query, page } });
        },

        search(val) {
            if (val == null) {
                const body = {
                    query: this.query,
                    status: 6,
                };
                this.getSupplierGifts(body);
            } else {
                this.debouncedSearch();
            }
        },
    },
    mounted() {
        const body = {
            query: this.query,
            status: 6,
        };
        this.getSupplierGifts(body);
    },
    beforeCreate() {
        if (!this.$route.query.page) {
            this.$router.push({
                query: {
                    page: 1,
                    ...this.$route.query,
                },
            });
        }
    },
    created() {
        this.debouncedSearch = debounce(this.handleSearch, 500);
    },
};
</script>
